<template>    
   <BaseModal
        :id="'static'"
        :title="title"
        message="In this view, you can see and edit the details of your selected item. To make changes, simply click on a field, update the information, and click 'Save'. If you're adding a fixed item from the assignment notes, you can filter the assignments by their shift."
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                    :content_align_x="'justify-content-start'"
                />
                <!-- <div class="formdynamic__item py-0 col-md-4 p-0" style="margin-top: 20px;">
                    <div class="formdynamic__item__field">
                        <label for="Include in census:" class="modal-label">Enter Manually Annual Minutes </label>
                        <span class="custom-control custom-checkbox">
                            <input id="refAlt14undefined" type="checkbox" class="custom-control-input" value="">
                            <label for="refAlt14undefined" class="custom-control-label ml-2"></label>
                        </span>
                    </div>
                </div> -->

                <CentralButtons />
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {

    name:   'FormModal',
    props: [
        "title",
        "parent_id",
        "content_header",
        "rest_api",
        "notifications",
        "notyf",
        "axios",
        "array_options",
        "date",
        "breadcrumb",
        "maximum_order"
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            levels:         [],
            areas:          [],
            form_data:      FormResources.form_data,
            form_format:    FormResources.form_format,
            form_backup:    {...FormResources.form_data},
        }
    },

    methods:{
        async getDailyAssignments()
        {
            if(!this.array_options['daily_assignment_id'])
            {
                this.loader(true)
            }

            const res = await this.get(`general_functions/assignments`)

            if(res.status)
            {
                this.$emit('updateArrayOptions', {daily_assignment_id: res.data.daily_assignments})
                this.$emit('updateBackupDailyAssignments', {daily_assignments: res.data.daily_assignments})
            }
            else
            {
                this.error_handling(res)
            }

            this.loader()
        },

        async getDutyNotesMinutes(daily_assignment_id)
        {
            const res = await this.post(`${this.rest_api}/get/minutes_from_duty_notes`, {daily_assignment_id})

            if(res.status)
            {
                this.form_data.daily_minutes = res.data.minutes
            }
            else
            {
                this.error_handling(res)
            }
        },
    },

    mounted(){
    },
    watch: {

        date (newVal) {
            this.form_data.date = newVal;
            this.form_data.updated_date = newVal;
        },

        parent_id (val) {
            this.form_data.staffing_scenario_id = val
            this.form_backup.staffing_scenario_id = val
        },

        "form_data.frequency_week" (newVal, oldVal) {
            if(!this.form_data.annual_minutes_manual || this.form_data.from_assignment_notes)
            {
                if (newVal) {
                    if (newVal <= 0) {
                        this.form_data.frequency_week = oldVal
                        this.notyf.error('Frecuency Week must be greater than 0')
                    } else {
                        this.form_data.annual_minutes = this.form_data.daily_minutes ? (this.form_data.daily_minutes * newVal * 52).toFixed(2) : '' 
                    }
                } else {
                    this.form_data.annual_minutes = ''
                }
            }
        },

        "form_data.daily_minutes" (newVal) {
            if(!this.form_data.annual_minutes_manual || this.form_data.from_assignment_notes)
            {
                if (newVal) 
                {
                    newVal = newVal.toString();
            
                    let parts = newVal.split('.');
                    
                    if (parts.length > 1) 
                    {
                        parts[1] = parts[1].substring(0, 2);
                    }
                    
                    newVal = parts.join('.');
                    
                    this.form_data.daily_minutes = newVal

                    this.form_data.annual_minutes = this.form_data.frequency_week ? (this.form_data.frequency_week * newVal * 52).toFixed(2) : ''
                    
                } else {
                    this.form_data.annual_minutes = ''
                }
            }
        },

        'form_data.shift_class'(val) {
            this.form_data.daily_assignment_id = []
            this.$emit('updateArrayOptions', {daily_assignment_id: this.array_options.daily_assignments.filter(item => item.shift_class === val)})
        },

        'form_data.annual_minutes_manual'(val) {
           this.form_format[5].disabled = !val
           if(!val)
           {
            const frequency = this.form_data.frequency_week
            this.form_data.frequency_week = 0
            setTimeout(() => {
                this.form_data.frequency_week = frequency
            }, 5);
           }
        },

        "form_data.from_assignment_notes"(newVal)
        {
            if(!newVal)
            {
                this.form_format = FormResources.form_format
            }
            else
            {
                this.form_data.annual_minutes_manual = false
                setTimeout(() => {
                    this.form_format = FormResources.form_format_2
                }, 10);

                this.getDailyAssignments()
            }
        },
        'form_data.daily_assignment_id': {
            handler(val) {
                this.getDutyNotesMinutes(val);
            },
            deep: true
        }
        
    } 

    
}
</script>